<template>
  <!-- Navbar -->
  <div
    style="
      position: relative;
      top: 50px;
      left: 0;
      height: calc(100% - 50px);
      width: 350px;
      border-right: 1px solid #ccc;
    ">
    <v-skeleton-loader
      :loading="true"
      class="skeleton-button" />

    <v-skeleton-loader
      :loading="true"
      class="skeleton-input" />

    <div
      style="
        width: 100%;
        height: 100%;
        background-color: white;
        padding-top: 10px;
      ">
      <v-skeleton-loader
        :loading="true"
        class="skeleton-tree-node" />
      <v-skeleton-loader
        :loading="true"
        class="skeleton-tree-node ml-50" />

      <v-skeleton-loader
        :loading="true"
        class="skeleton-tree-node ml-100" />

      <v-skeleton-loader
        :loading="true"
        class="skeleton-tree-node ml-150" />

      <v-skeleton-loader
        :loading="true"
        class="skeleton-button bottom" />
    </div>
  </div>

  <div style="position: absolute; top: 50%; left: calc(50% + 175px)">
    <v-progress-circular indeterminate></v-progress-circular>
  </div>
</template>

<script setup></script>

<style scoped lang="scss">
.skeleton-button {
  width: calc(100% - 20px);
  height: 40px;
  border-radius: 50px;
  margin: 10px;
}

.skeleton-input {
  width: calc(100% - 20px);
  height: 40px;
  border-radius: 5px;
  margin: 10px;
}

.skeleton-tree-node {
  width: 180px;
  height: 40px;
  border-radius: 5px;
  margin: 10px;

  &.ml-50 {
    margin-left: 50px;
  }

  &.ml-100 {
    margin-left: 100px;
  }

  &.ml-150 {
    margin-left: 150px;
  }

  &.ml-200 {
    margin-left: 200px;
  }
}

.bottom {
  position: absolute;
  bottom: 0;
}
</style>
